import { render, staticRenderFns } from "./RegistrosIcmsInterno.vue?vue&type=template&id=60103957&scoped=true&"
import script from "./RegistrosIcmsInterno.vue?vue&type=script&lang=js&"
export * from "./RegistrosIcmsInterno.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosIcmsInterno.vue?vue&type=style&index=0&id=60103957&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60103957",
  null
  
)

export default component.exports